import sortBy from 'lodash/sortBy'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

export default class OverlayWorkspaceList extends Component {
  static propTypes = {
    workspaces: PropTypes.array.isRequired
  }

  renderWorkspace(workspace) {
    return (
      <div className="clear-both workspace-container" key={workspace.id}>
        <a
          href={Tru.Utils.buildBaseURL(`workspaces/${workspace.id}`)}
          className="title"
        >
          {workspace.name}
        </a>
      </div>
    )
  }

  render() {
    let { workspaces } = this.props
    workspaces = sortBy(workspaces, workspace => workspace.name.toLowerCase())

    if (workspaces.length === 0) {
      return (
        <span className="grey-reg-i">{I18n.t('No workspaces to display')}</span>
      )
    }

    return <div>{workspaces.map(this.renderWorkspace)}</div>
  }
}



// WEBPACK FOOTER //
// ../src/components/OverlayWorkspaceList.js